/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';
import { NavigationSection } from './defs/NavigationSection.defs';

/**
 * The props for `<SideNav />`.
 */
export interface SideNavProps extends SdsDivProps {
  /**
   * Side menu heading.
   */
  menuHeading?: string;

  /**
   * SideNav sections.
   */
  sections: Array<NavigationSection>;
}

/**
 * The default prop values for `<SideNav />`.
 */
export const sideNavDefaults = {
  menuHeading: `Main Menu`,
};
